import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const FilterError: React.FC = () => {
    const { t } = useTranslation('translations')
    const titleError = t('filters.error_title')
    const descriptionError = t('filters.no_nodes_or_commodities')

    return (
        <div
            data-testid="node-commodity-filter-error"
            className="flex h-full w-full flex-col items-center justify-center px-6 py-12 text-center"
        >
            <img
                src="/assets/unable-to-load-data.png"
                data-testid="filter-error-image"
                alt="No nodes or commodities"
                className="mb-4"
            />
            <div className="space-y-2">
                <h1
                    data-testid="filter-error-title"
                    className="text-heading-6 text-regular"
                >
                    {titleError}
                </h1>
                <p
                    data-testid="filter-error-message"
                    className="mx-auto whitespace-pre-line text-center text-sm font-normal leading-6 text-subtle"
                >
                    {descriptionError}
                </p>
            </div>
        </div>
    )
}
